import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import card from "../../assets/card.svg";
import logoCobee from "../../assets/logo-cobee.svg";
import virtualAndPhysicalCards from "../../assets/virtual-and-physical-cards.png";
import { Logout } from "../../components/Logout";
import Button from "../../components/button";
import { ButtonVariant } from "../../components/button/Button.types";
import { Footer } from "../../components/footer";
import { useMetrics } from "../../metrics";
import { ROUTES } from "../../routes";
import classes from "./RequestCard.module.css";
import { useFeatures } from "./useFeatures";

const RequestCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pageView, trackAction } = useMetrics();
  const { data: features, isLoading } = useFeatures();

  const handleOnClickRequestCardButton = () => {
    trackAction.click({
      screenName: "RequestCard",
      componentName: "button request card",
    });
    navigate(ROUTES.ADD_ADDRESS);
  };

  const requestVirtualCard = () => {
    trackAction.click({
      screenName: "RequestVirtualCard",
      componentName: "button request virtual card",
    });
    navigate(ROUTES.ADD_PHONE, { state: { virtualCard: true } });
  };

  const requestOnlyVirtualCard = () => {
    trackAction.click({
      screenName: "RequestVirtualCard",
      componentName: "Only Virtual Card Button Pressed",
    });
    navigate(ROUTES.ADD_PHONE, { state: { virtualCard: true } });
  };

  useEffect(() => {
    pageView("RequestCard");
  }, [pageView]);

  if (isLoading) return null;

  return (
    <div className={classes.container}>
      <header className="grid grid-cols-12 mt-4 h-16 items-center w-4/5">
        <div className="flex justify-center col-start-3 col-span-8">
          <img className={classes.logo} src={logoCobee} alt="Logo de Cobee" />
        </div>
        <div className="col-span-1 items-start w-max">
          <Logout />
        </div>
      </header>
      {features?.hasDecoupleVirtualCard && (
        <div className={classes.infoContainer}>
          <h1 className={classes.title}>
            {t("request-virtual-card.start.title")}
          </h1>
          <p className={classes.description}>
            {t("request-virtual-card.start.description")}
          </p>
          <img
            data-testid="request-physical-and-virtual-card-image"
            className={classes.cards}
            src={virtualAndPhysicalCards}
            alt=""
            aria-hidden="true"
          />
          <div className={classes.buttonsContainer}>
            <Button
              onClick={requestVirtualCard}
              text={t("request-virtual-card.start.button-virtual")}
            />
            <Button
              onClick={handleOnClickRequestCardButton}
              text={t("request-virtual-card.start.button-physical-and-virtual")}
              variant={ButtonVariant.GHOST}
            />
          </div>
        </div>
      )}
      {features?.hasOnlyVirtualCard && (
        <div className={classes.infoContainer}>
          <h1 className={classes.title}>
            {t("request-virtual-card.start.title")}
          </h1>
          <p className={classes.description}>
            {t("request-virtual-card.start.description")}
          </p>
          <img
            data-testid="request-only-virtual-card-image"
            className={classes.cards}
            src={virtualAndPhysicalCards}
            alt=""
            aria-hidden="true"
          />
          <div className={classes.buttonsContainer}>
            <Button
              onClick={requestOnlyVirtualCard}
              text={t("request-card.start.only-virtual.button")}
            />
          </div>
        </div>
      )}
      {!features?.hasDecoupleVirtualCard && !features?.hasOnlyVirtualCard && (
        <div className={classes.infoContainer}>
          <h1 className={classes.title}>{t("request-card.start.title")}</h1>
          <p className={classes.description}>
            {t("request-card.start.subtitle")}
          </p>
          <img
            className={classes.card}
            src={card}
            alt={t("request-card.start.img-alt")}
          />
          <div className={classes.buttonContainer}>
            <Button
              onClick={handleOnClickRequestCardButton}
              text={t("request-card.start.button")}
            />
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export { RequestCard };
